import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {UserGroup} from '@core/api/data-access';
import {IconComponent} from '@shared/icon';

@Component({
	selector: 'dc-usergroup-result-item', // Standard prefix 'dc'
	imports: [IconComponent],
	templateUrl: './usergroup-result-item.component.html', // Separate template
	styleUrls: ['./usergroup-result-item.component.scss', '../result-item.shared.scss'], // Separate styles
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserGroupResultItemComponent {
	// --- Inputs ---
	readonly item = input.required<UserGroup>(); // Define the required 'item' input

	// --- Constructor ---
	constructor() {}

	// --- Lifecycle Hooks ---

	// --- Methods / Getters (Optional) ---
	// No specific getters needed for now based on the HTML structure below
}
